// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3gpVr","loaderOuter":"PageOverlayLoader_loaderOuter__3lF9r"};